export class AppEventSupport {
    constructor() {
        this.activateHandler = new Set();
        this.deactivateHandler = new Set();
        this.idleHandler = new Set();
        this.deactivateVetos = 0;
        this.locationCodeHandler = new Set();
        this.canAutoDeactivateHandler = new Set();
        this.barcodeHandler = new Set();
        this.keypadHandler = new Set();
        this.admissionHandler = new Set();
    }
    activate(item) {
        for (let handler of this.activateHandler) {
            handler(item);
        }
    }
    async deactivate() {
        if (this.deactivateVetos <= 0) {
            for (let handler of this.deactivateHandler) {
                await handler();
            }
        }
        else {
            throw new Error("Deactivate not allowed");
        }
    }
    canAutoDeactivate() {
        if (this.deactivateVetos > 0) {
            return false;
        }
        for (let handler of this.canAutoDeactivateHandler) {
            if (!handler()) {
                return false;
            }
        }
        return true;
    }
    idle() {
        this.idleHandler.forEach(idleHandler => idleHandler());
    }
    barcodeScanned(barcode) {
        console.log("AppEventSupport.barcodeScanned", { handlerCount: this.barcodeHandler.size });
        this.barcodeHandler.forEach(handler => handler(barcode));
    }
    accessCodeEntered(code) {
        console.log("AppEventSupport.accessCodeEntered", { handlerCount: this.keypadHandler.size });
        this.keypadHandler.forEach(handler => handler(code));
    }
    async admissionCodeReceived(code) {
        console.log("AppEventSupport.admissionCodeReceived", { handlerCount: this.admissionHandler.size });
        for (let handler of this.admissionHandler) {
            const result = await handler(code);
            if (result)
                return result;
        }
        return null;
    }
    updateLocationCode(code) {
        for (let handler of this.locationCodeHandler) {
            handler(code);
        }
    }
    get displaysLocationCode() {
        return this.locationCodeHandler.size > 0;
    }
    addActivateListener(handler) {
        this.activateHandler.add(handler);
    }
    addDeactivateListener(handler) {
        this.deactivateHandler.add(handler);
    }
    addCanAutoDeactivateListener(handler) {
        this.canAutoDeactivateHandler.add(handler);
    }
    removeActivateListener(handler) {
        this.activateHandler.delete(handler);
    }
    removeDeactivateListener(handler) {
        this.deactivateHandler.delete(handler);
    }
    removeCanAutoDeactivateListener(handler) {
        this.canAutoDeactivateHandler.delete(handler);
    }
    addIdleListener(handler) {
        this.idleHandler.add(handler);
    }
    removeIdleListener(handler) {
        this.idleHandler.delete(handler);
    }
    addLocationCodeListener(handler) {
        this.locationCodeHandler.add(handler);
    }
    removeLocationCodeListener(handler) {
        this.locationCodeHandler.delete(handler);
    }
    addBarcodeListener(listener) {
        this.barcodeHandler.add(listener);
    }
    removeBarcodeListener(listener) {
        this.barcodeHandler.delete(listener);
    }
    addKeypadListener(listener) {
        this.keypadHandler.add(listener);
    }
    removeKeypadListener(listener) {
        this.keypadHandler.delete(listener);
    }
    addAppAdmissionListener(listener) {
        this.admissionHandler.add(listener);
    }
    removeAppAdmissionListener(listener) {
        this.admissionHandler.delete(listener);
    }
    allowDeactivate(allow) {
        if (allow) {
            this.removeDeactivateVeto();
        }
        else {
            this.addDeactivateVeto();
        }
    }
    addDeactivateVeto() {
        this.deactivateVetos++;
        if (this.deactivateVetos >= 20) {
            console.warn("addDeactivateVeto has been called 20x more often than removeDeactivateVeto. This is very likely a bug.");
        }
    }
    removeDeactivateVeto() {
        if (this.deactivateVetos > 0) {
            this.deactivateVetos--;
        }
        else {
            console.warn("removeDeactivateVeto has been called more often than addDeactivateVeto. This is very likely a bug.");
        }
    }
}
//# sourceMappingURL=AppEventSupport.js.map